import { BlogIndex } from '@kkf/design'
import { POSTS } from '../data/blog'
import { useT } from '../i18n'

/**
 * The blog index, from the library all four public sites share.
 *
 * The page is `@kkf/design`'s `BlogIndex`; this file is which posts and what this site
 * calls its blog. See `data/blog` for how the posts get here.
 *
 * **`/blog` and `/blog/*` are in this app's `header.plainRoutes`** — both open on their own
 * pale content and the bar's links are white at rest. `BlogIndex` carries
 * `.ul-plain-page-top` itself; the route list is the half it cannot do for itself.
 */
export function BlogPage() {
  const t = useT()
  return <BlogIndex posts={POSTS} title={t('page.blog')} />
}
